// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Leaderboard_leaderboard__wt\\+aF {
  width: 100%;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.Leaderboard_leaderboard__title__lL3bA {
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--accent-color);
  margin: 0;
}
.Leaderboard_leaderboard__description__Id4Mm {
  font-size: 14px;
  color: var(--grey-text);
  line-height: 1.6;
  margin: 0;
}
.Leaderboard_leaderboard__chart__6-dXN {
  width: 100%;
}
.Leaderboard_leaderboard__toggle__ln6be {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 6px 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--grey-text);
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: color 0.2s;
}
.Leaderboard_leaderboard__toggle__ln6be:hover {
  color: var(--accent-color);
}
.Leaderboard_leaderboard__toggle-arrow__ypxmn {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/Leaderboard/Leaderboard.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,+DAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AACJ;AAEE;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAIE;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;AAFJ;AAII;EACE,0BAAA;AAFN;AAME;EACE,eAAA;AAJJ","sourcesContent":[".leaderboard {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  padding: 28px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  &__title {\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--accent-color);\n    margin: 0;\n  }\n\n  &__description {\n    font-size: 14px;\n    color: var(--grey-text);\n    line-height: 1.6;\n    margin: 0;\n  }\n\n  &__chart {\n    width: 100%;\n  }\n\n  &__toggle {\n    align-self: flex-start;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: none;\n    border: none;\n    padding: 6px 0;\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--grey-text);\n    letter-spacing: 0.5px;\n    cursor: pointer;\n    transition: color 0.2s;\n\n    &:hover {\n      color: var(--accent-color);\n    }\n  }\n\n  &__toggle-arrow {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leaderboard": `Leaderboard_leaderboard__wt+aF`,
	"leaderboard__title": `Leaderboard_leaderboard__title__lL3bA`,
	"leaderboard__description": `Leaderboard_leaderboard__description__Id4Mm`,
	"leaderboard__chart": `Leaderboard_leaderboard__chart__6-dXN`,
	"leaderboard__toggle": `Leaderboard_leaderboard__toggle__ln6be`,
	"leaderboard__toggle-arrow": `Leaderboard_leaderboard__toggle-arrow__ypxmn`
};
export default ___CSS_LOADER_EXPORT___;
